import { Controller } from '@hotwired/stimulus'
import tippy from 'tippy.js'
import htmx from "htmx.org"

export default class Tooltip extends Controller {
  static values = {
    lazyLoadUrl: String,
    loadingHtml: String
  }

  initialize() {
    this.contentLoaded = false

    this.instance = tippy(this.element, {
      content: this.loadingHtmlValue,
      allowHTML: true,
      trigger: "click",
      placement: "bottom-end",
      arrow: false,
      theme: "br-calendar-popup",
      maxWidth: 500,
      interactive: true,
      popperOptions: {
        strategy: "fixed"
      }
    })
  }

  // Load the content on hover, instead of click, for a slightly better UX.
  // Inspiration: http://instantclick.io/
  async loadContent() {
    // If the content is already loaded, no need to load it again
    if (this.contentLoaded) return

    try {
      // Lazy-load popup content
      const response = await fetch(this.lazyLoadUrlValue)
      const html = await response.text()
      const node = document.createElement('div')
      node.innerHTML = html
      this.instance.setContent(node)

      // Connect HTMX listeners
      htmx.process(node)

      this.contentLoaded = true
    } catch(error) {
      // Fallback if the network request failed
      this.instance.setContent(`Request failed. ${error}`)
    }
  }

  hide() {
    this.instance.hide()
  }
}
